import React from 'react';
import { DialogUI, FileTabUI } from '../../Interface';
import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { sxConfig } from './ProjectHistory.style';

const ProjectTaskListReport = ({ open, handleClose, task }) => {
  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Lejelentés"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
          },
        },
      }}
    >
      <Box mt="1rem">
        <Box display="flex" gap="0.5rem 2rem" mb="2rem" flexWrap="wrap">
          <Box>
            <Typography variant="caption" sx={sxConfig.caption}>
              Lejelentő
            </Typography>
            <Typography>{task?.user?.userName}</Typography>
          </Box>
          <Box>
            <Typography variant="caption" sx={sxConfig.caption}>
              Lejelentés dátuma
            </Typography>
            <Typography>{dayjs(task?.createdAt).format('YYYY-MM-DD HH:mm')}</Typography>
          </Box>
          <Box>
            <Typography variant="caption" sx={sxConfig.caption}>
              Kivitelezés ideje
            </Typography>
            <Typography>{dayjs(task?.executionTime).format('YYYY-MM-DD HH:mm')}</Typography>
          </Box>
          <Box>
            <Typography variant="caption" sx={sxConfig.caption}>
              Csoport
            </Typography>
            <Typography>{task?.userGroup?.name}</Typography>
          </Box>
          <Box>
            <Typography variant="caption" sx={sxConfig.caption}>
              Megjegyzés
            </Typography>
            <Typography
              sx={{
                overflowWrap: 'anywhere',
                wordBreak: 'break-word',
                whiteSpace: 'pre-wrap',
              }}
            >
              {task?.description}
            </Typography>
          </Box>
        </Box>
        <FileTabUI savedFiles={task?.taskListReportAttachment ?? []} />
      </Box>
    </DialogUI>
  );
};

export default ProjectTaskListReport;
